
export default {


  confirm: {
    tips: {
      title: '※加盟店申请须知',
      subtitle: '感谢您申请成为日本环球支付株式会社的加盟店。',
      content: '为完成加盟手续，您需要通过本系统填写公司及代表人信息，并上传各类证明文件。',
      content1: '此流程依据相关法律法规要求，至关重要。烦请依照系统步骤操作，并提供准确、最新的信息。',

    },
    contract: {
      title: '基于法令的加盟店责任事项。',
     subtitle: '请理解并同意以下关于基于法令的加盟店责任事项。',

      expand: '展开',
      collapse: '收起',
      terms: {
        title: '加盟店合约条款',
        subtitle: '作为日本非现金支付服务加盟店的义务',
        confirmText: '本人已仔细阅读并完全理解上述所有条款内容，并同意遵守所有规定。',
        // 引言段落
        intro1: '贵方成为日本非现金支付服务加盟店后，将承担下述法律及行业规则所规定的义务。',
        intro2: '此系因加盟店所提供之服务，根据《分期付款销售法》等法律法规，对社会生活具有重大影响。倘若加盟店进行任何违反法令的营业行为，将对用户等造成重大损失与困扰。',
        intro3: '恳请贵方充分理解上述责任及违规后果，并在今后的经营活动中严格遵守。',

        // 第一部分标题
        section1Title: '（一）基于法律法规的加盟店责任',
        section1Intro: '根据相关法律法规，加盟店须承担如下责任：',

        // 责任表格
        responsibility: {
          tableHeader: {
            item: '项　目',
            content: '内　容'
          },
          items: [
            {
              no: '①合规守法',
              content: '加盟店应严格遵守一切适用的法律法规、行业规则及其他合规要求，并不得从事任何与之相抵触的营业或宣传活动。'
            },
            {
              no: '②反社会势力断绝条款',
              content: '暴力团等反社会势力不具备加盟店资格。若在合约存续期间发现其属于或涉足反社会势力，我方有权单方面立即解除本合约。'
            },
            {
              no: '③发生违规时的报告责任',
              content: '加盟店发生任何合规违规时，均须立即向本公司报告。若故意隐瞒不报，则构成重大违约，本公司有权单方解除本合约。'
            },
            {
              no: '④客户信息管理规范',
              content: '加盟店应妥善管理客户信息，并确保其安全。若发生任何信息泄露、丢失、毁损等安全事件，须立即向本公司报告。'
            },
            {
              no: '⑤（登记）事项变更报告义务',
              content: '加盟店的申请事项均依法设定。若法定代表人、地址发生变更，或增设子加盟店等任何已申报信息出现变动，必须立即向本公司报告。'
            },
            {
              no: '⑥公司内部体制完善与员工教育',
              content: '加盟店为切实履行本协议前述各项义务，须建立健全相应的内部管理制度，并必须对相关员工进行持续的教育与培训。'
            }
          ]
        },

        // 第二部分标题
        section2Title: '（二）加盟店违约处理措施',
        section2Intro: '加盟店违反本合约（一）规定时，我方可能采取以下一项或多项措施：',

        // 处理措施
        measures: [
          '暂停或终止提供支付服务，乃至解除本合约；',
          '对违规行为进行公示，或根据情况向监管机构报告，可能导致贵司受到业务整改命令、业务停止处分等行政处罚；',
          '贵司的违法行为，将依法承担相应的行政或刑事责任。'
        ],

        // 确认部分
        confirmText: '本人已仔细阅读并完全理解上述所有条款内容，并同意遵守所有规定。'


      }
    },
    specificterms: {
      title: '个别确认事项',
       header: {
        checkbox: '【申请前确认】 本人确认并同意以下事项：',
        description: ''
      },
      terms: {
        item1: '本人知悉，本次申请的收单机构为 "经济产业大臣注册非现金支付服务提供商——日本环球支付株式会社"。',
        item2: '本人同意，为完成本次申请，向贵社提供所需的一切信息。',
        item3: {
          prefix: '本人承诺，若成为加盟店，将严格遵守所有相关法律法规及贵社制定的',
          globepay: '《GLOBEPAY加盟店管理规约》',
          middle: '以及',
          terms: '《关于结算终端及相关设备的买卖条款》',
          suffix: '。'
        },
        item4: {
          main: '申请人（法定代表人及公司）需符合以下法令要求，无相关违法记录：',
          sub1: {
            text: '非《反暴力团法》规定的暴力团等反社会势力。',
            note: '※关于非反社会势力的声明，请在"（三）"部分的"声明与承诺书"中填写必要事项。'
          },
          sub2: '过去5年内未受到《特定商业交易法》规定的处罚。',
          sub3: '未曾因违反《消费者契约法》而在民事诉讼中被判败诉。'
        }
      },
      documentLinks: {
        globepay: '../../conditions.html',
        terms: '../../terms.html'
      }

    },
    agreesection: {
      title: '在确认并同意上述(一)、（二）及（三）项所载全部事项的基础上，予以签署。',
      content: '此外，本人同意，若在申请后或成为加盟店后，发现存在与事实不符的事项，本次申请可能被视为无效，或加盟店资格可能被取消。',

    },
    confirm: {
      title: '事先确认',
      label1: '1.收单机构：日環球支付株式会社',
      label2: '2.我同意向收单机构提供申请信息和支付服务使用情况',
      label3: '3.您或您的管理人员不属于GlobePay支付服务会员店协议第二十四条第一项规定的反社会势力范畴',
      label4: '4.不属于娱乐业管理等法第二条第一项及事业拨款等规定之经营娱乐业之业者',
      label5: '5.特定商业交易法/消费者合同法的违反记录',
      tip: '※过去五年内，未受到特定商业交易法的处罚，也未因违反消费者合同法而在民事诉讼中受到败诉',
    },
    transaction: {
      title: '交易形式',
      label1: '交易类型不属于①至⑥',
      label2: '①上门销售',
      label3: '②特定持续服务提供',
      label4: '③电话推销销售',
      label5: '④预付式服务交易',
      label6: '⑤业务合作诱导销售',
      label7: '⑥连锁销售',
      tip: '不属于下述①～⑥交易方式 ※如有，请勾选下述①～⑥的相应内容',
    },
    manage: {
      title: '关于运营形态，加盟店的运营形态如下所述。',
      store: '单个店铺',
      concession: '连锁店铺',
      no: '不适用',
      status1: '单店经营（本次申请店铺仅为总店）',
      status2: '特许经营',
      status3: '本次将同期开设总店以外的分店',
      status4: '今后有计划开设总店以外的分店',


    },
    statement: {
      title: '关于非暴力团等反社会势力的声明及承诺书',
      tip: '在签订有关使用日本环球基金株式会社提供的处理合同签订业务的信用卡号码的合同时，我们特此声明并确认，我们不是有组织犯罪或其他反社会势力的组织。',
      label1: {
        title: '１. 您或贵公司是否为反社会势力？',
        tip: '我方或我公司现声明并承诺，现在及将来均不属于以下任何一项反社会势力：',
        label1: '① 暴力团',
        label2: '② 暴力团员',
        label3: '③ 暴力团关联企业',
        label4: '④ 总会屋、以社会运动为幌子的流氓团伙、以政治活动为幌子的流氓团伙、特殊智能暴力集团等',
        label5: '⑤ 其他与上述各项性质相当者',
        label1yes: '我方或我公司并非反社会势力。',
        label1no: '我方或我公司是反社会势力。',
      },
      label2: {
        title: '2. 您或贵公司是否与反社会势力等存在关联？',
        tip: '我方或我公司现声明并承诺，现在及将来亦不与同前项所述反社会势力有密切交往关系者（下称“反社会势力等”）存在以下任何一项关系：',
        label1: '① 经营受反社会势力等控制的关联',
        label2: '② 反社会势力等实质参与经营的关联',
        label3: '③ 向反社会势力等提供资金或给予便利等的关联',
        label4: '④ 其他与反社会势力等之间的、应受社会谴责的关联',
        label2yes: '我方或我公司与反社会势力等无任何关联。',
        label2no: '我方或我公司与反社会势力等存在关联。',
      },
      label3: {
        title: '３.您或贵公司是否会实施暴力性要求行为等？',
        tip: '我方或我公司声明并承诺，绝不自行或利用第三方实施下列任何一项行为：',
        label1: '① 暴力性要求行为',
        label2: '② 超越法律责任的不当要求行为',
        label3: '③ 就交易进行胁迫性言论或使用暴力的行为',
        label4: '④ 散布谣言、使用欺诈或威吓手段损害贵公司信誉，或妨碍贵公司业务的行为',
        label5: '⑤ 其他与前述各项类似的行为',
        label3yes: '我方或我公司绝不实施任何暴力性要求行为等。',
        label3no: '我方或我公司会实施暴力性要求行为等。',
      },
      label4: {
        title: '４.若贵方或贵公司属于反社会势力，是否对交易被停止或合约被解除无任何异议？',
        tip: '我方或我公司声明并承诺：若被认定不符合本声明书中任何一项承诺，或本声明、承诺被证实为虚假陈述时，即使交易被立即停止或合约被解除且无需任何催告，我方或我公司也将不提出任何异议，不要求任何赔偿或补偿；且因此产生的一切损失，均由我方或我公司自行承担全部责任。',
        label1: '以上',

        label4yes: '无异议',
        label4no: '有异议',
      },
    },
    autograph: {
      legalrepposition: '代表人职务',
      legalname: '姓名',
      autograph: '本人已确认并签署上述事项',
      btn: '签名',
      clear: '清除',
      ok: '确认',
      errorMsg: '请签名',
    },
    file: '勾选并同意《GlobePay支付服务商户条款》',
    file2: '',
    terms: '勾选并同意有关支付终端和相关设备的销售条款',
    liabilityterms: '请理解并同意以下关于基于法令的加盟店责任事项。',



  }
}
